import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5 } from "styled-components";
import "core-js/modules/web.dom-collections.iterator.js";
import { useState, useRef } from "react";
import styled, { css } from "styled-components";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Icon from "../../../../../Styled/Icon";
import Box from "../../../../../Styled/Box";
import { TextSpan } from "../../../../../Styled/Text";
import { RawButton } from "../../../../../Styled/Button";
import Spacing from "../../../../../Styled/Spacing";
import MapIconButton from "../../../../MapIconButton/MapIconButton";
// import MenuPanel from "../StandardUserInterface/customizable/MenuPanel";
import CleanDropdownPanel from "../../../../CleanDropdownPanel/CleanDropdownPanel";
import { COMPASS_LOCAL_PROPERTY_KEY } from "./Compass";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
GyroscopeGuidance.propTypes = {
  viewState: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired
};
const Text = styled(TextSpan).attrs({
  textAlignLeft: true,
  noFontSize: true
}).withConfig({
  displayName: "GyroscopeGuidance__Text",
  componentId: "sc-1hk2wdp-0"
})([""]);
const CompassWrapper = styled(Box).attrs({
  centered: true,
  styledWidth: "64px",
  styledHeight: "64px"
}).withConfig({
  displayName: "GyroscopeGuidance__CompassWrapper",
  componentId: "sc-1hk2wdp-1"
})(["flex-shrink:0;svg{fill:", ";}"], props => props.theme.textDarker);
const CompassPositioning = "\n\n";
const CompassIcon = styled(Icon).withConfig({
  displayName: "GyroscopeGuidance__CompassIcon",
  componentId: "sc-1hk2wdp-2"
})(["position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);", " ", ""], props => props.inner ? "\n      fill: ".concat(props.theme.textDarker, ";\n      width: 26px;\n      height: 26px;\n    ") : "\n      fill: ".concat(props.theme.textLight, ";\n      width: 64px;\n      height: 64px;\n    "), props => props.darken && "\n      opacity: 0.2;\n    ");
var _StyledCompassIcon = styled(CompassIcon).withConfig({
  displayName: "GyroscopeGuidance___StyledCompassIcon",
  componentId: "sc-1hk2wdp-3"
})(["", ""], CompassPositioning);
function GyroscopeGuidancePanel(props) {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsxs(_StyledBox, {
    column: true,
    paddedRatio: 4,
    children: [/*#__PURE__*/_jsx(Text, {
      large: true,
      children: t("compass.guidance.title")
    }), /*#__PURE__*/_jsx(Spacing, {
      bottom: 4
    }), /*#__PURE__*/_jsxs(Text, {
      medium: true,
      children: [/*#__PURE__*/_jsxs(Box, {
        children: [/*#__PURE__*/_jsxs(CompassWrapper, {
          children: [/*#__PURE__*/_jsx(CompassIcon, {
            glyph: Icon.GLYPHS.compassOuterEnlarged
          }), /*#__PURE__*/_jsx(CompassIcon, {
            glyph: Icon.GLYPHS.compassInnerArrows,
            inner: true,
            darken: true
          })]
        }), /*#__PURE__*/_jsx(Spacing, {
          right: 2
        }), /*#__PURE__*/_jsxs(Box, {
          column: true,
          children: [/*#__PURE__*/_jsx(Text, {
            bold: true,
            uppercase: true,
            children: t("compass.guidance.outerRingTitle")
          }), /*#__PURE__*/_jsx(Spacing, {
            bottom: 1
          }), /*#__PURE__*/_jsx(Text, {
            children: t("compass.guidance.outerRingDescription")
          })]
        })]
      }), /*#__PURE__*/_jsx(Spacing, {
        bottom: 4
      }), /*#__PURE__*/_jsxs(Box, {
        children: [/*#__PURE__*/_jsxs(CompassWrapper, {
          children: [/*#__PURE__*/_jsx(_StyledCompassIcon, {
            glyph: Icon.GLYPHS.compassOuterEnlarged,
            darken: true
          }), /*#__PURE__*/_jsx(CompassIcon, {
            glyph: Icon.GLYPHS.compassInnerArrows,
            inner: true
          }), /*#__PURE__*/_jsx(Spacing, {
            right: 2
          })]
        }), /*#__PURE__*/_jsx(Spacing, {
          right: 2
        }), /*#__PURE__*/_jsxs(Box, {
          column: true,
          children: [/*#__PURE__*/_jsx(Text, {
            bold: true,
            uppercase: true,
            children: t("compass.guidance.innerCircleTitle")
          }), /*#__PURE__*/_jsx(Spacing, {
            bottom: 1
          }), /*#__PURE__*/_jsx(Text, {
            children: t("compass.guidance.innerCircleDescription1")
          }), /*#__PURE__*/_jsx(Spacing, {
            bottom: 2
          }), /*#__PURE__*/_jsx(Text, {
            children: t("compass.guidance.innerCircleDescription2")
          })]
        })]
      }), /*#__PURE__*/_jsx(Spacing, {
        bottom: 4
      }), /*#__PURE__*/_jsx(Text, {
        children: t("compass.guidance.ctrlDragDescription")
      }), /*#__PURE__*/_jsx(Spacing, {
        bottom: 4
      }), /*#__PURE__*/_jsx(RawButton, {
        onClick: props.onClose,
        children: /*#__PURE__*/_jsx(TextSpan, {
          displayBlock: true,
          primary: true,
          isLink: true,
          children: t("compass.guidance.dismissText")
        })
      })]
    })]
  });
}
GyroscopeGuidancePanel.propTypes = {
  onClose: PropTypes.func.isRequired
};
export function GyroscopeGuidance(props) {
  const [controlPanelOpen, setControlPanelOpen] = useState(false);
  const controlsMapIcon = useRef();
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsxs(_StyledDiv, {
    children: [/*#__PURE__*/_jsx(_StyledMapIconButton, {
      roundLeft: true,
      buttonRef: controlsMapIcon,
      neverCollapse: true,
      iconElement: () => /*#__PURE__*/_jsx(Icon, {
        glyph: Icon.GLYPHS.questionMark
      }),
      onClick: () => setControlPanelOpen(!controlPanelOpen),
      inverted: true
    }), /*#__PURE__*/_jsx(_StyledDiv2, {
      onClick: e => e.preventDefault(),
      children: /*#__PURE__*/_jsx(CleanDropdownPanel
      // theme={dropdownTheme}

      // While opacity at this level is not ideal, it's the only way
      // to get the background to be transparent - another step up
      // is setting the opacity layer underneath, and a
      // pseudo-panel on top of it to keep the opacity on top.
      // but that's a lot to do right now
      //   - for a component that is still using sass
      //   - for 0.85 where the contrast is still great.
      , {
        cleanDropdownPanelStyles: css(["opacity:0.85;.tjs-sc-InnerPanel,.tjs-sc-InnerPanel__caret{background:", ";}"], p => p.theme.textBlack),
        refForCaret: controlsMapIcon,
        isOpen: controlPanelOpen,
        onOpenChanged: () => controlPanelOpen
        // onDismissed={() => setControlPanelOpen(false)}
        ,
        btnTitle: t("compass.guidanceBtnTitle"),
        btnText: t("compass.guidanceBtnText"),
        viewState: props.viewState,
        smallScreen: props.viewState.useSmallScreenInterface,
        children: /*#__PURE__*/_jsx(GyroscopeGuidancePanel, {
          onClose: () => {
            setControlPanelOpen(false);
            props.onClose();
            props.viewState.terria.setLocalProperty(COMPASS_LOCAL_PROPERTY_KEY, true);
          }
        })
      })
    })]
  });
}
var _StyledBox = styled(Box).withConfig({
  displayName: "GyroscopeGuidance___StyledBox",
  componentId: "sc-1hk2wdp-4"
})(["direction:ltr;min-width:295px;"]);
var _StyledDiv = styled("div").withConfig({
  displayName: "GyroscopeGuidance___StyledDiv",
  componentId: "sc-1hk2wdp-5"
})(["position:relative;"]);
var _StyledMapIconButton = styled(MapIconButton).withConfig({
  displayName: "GyroscopeGuidance___StyledMapIconButton",
  componentId: "sc-1hk2wdp-6"
})(["svg{margin:0px;width:25px;height:25px;}"]);
var _StyledDiv2 = styled("div").withConfig({
  displayName: "GyroscopeGuidance___StyledDiv2",
  componentId: "sc-1hk2wdp-7"
})(["position:relative;"]);